export default {
  agree: '/v3/serveScore/new/signPromise'
}
